import {SupportTicketAttachmentModel} from '../../../../model/support/support-ticket-attachment.model';
import {SupportPageHooks} from './support-page-hooks';

export type SupportTicketAttachmentDrawerState = {
  attachments: SupportTicketAttachmentModel[]
}

export const useSupportTicketAttachmentDrawerState = (ticketId: string): SupportTicketAttachmentDrawerState => {
  const [supportTicketAttachments, ] = SupportPageHooks.useSupportTicketAttachments(ticketId)

  return {
    attachments: supportTicketAttachments
  }
}